var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from './api';
import parseError from '@utils/helpers/parseError';
const notificationService = class notificationService {
    getUserNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.get('/notification');
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    markAsRead(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.patch(`/notification/${id}/read`);
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    deleteNotification(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.delete(`/notification/${id}`);
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    deleteReadNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield api.patch('/notification/readAll');
                return { success: true, data: res.data.data };
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    deleteAllNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield api.patch('/notification/deleteAll');
                return { success: true, data: res.data.data };
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
};
const NotificationService = new notificationService();
export default NotificationService;
